import { memo } from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { LogOut } from 'lucide-react';

function ExitNode({ data, selected }: NodeProps) {
  const config = (data.config as Record<string, unknown>) ?? {};
  const exitType = (config.exitType as string) ?? 'success';
  const isFailure = exitType === 'failure';

  return (
    <div
      className={`w-52 rounded-xl bg-white shadow-sm border border-zinc-200 border-l-4 ${isFailure ? 'border-l-red-500' : 'border-l-zinc-400'} ${
        selected ? 'ring-2 ring-emerald-400' : ''
      }`}
    >
      <Handle
        type="target"
        position={Position.Top}
        className={`!${isFailure ? 'bg-red-500' : 'bg-zinc-400'}`}
      />
      <div className="flex items-center gap-2 px-3 py-2 border-b border-zinc-100">
        <LogOut
          size={14}
          className={isFailure ? 'text-red-500 shrink-0' : 'text-zinc-400 shrink-0'}
        />
        <span className="text-xs font-semibold text-zinc-700 uppercase tracking-wide">Exit</span>
      </div>
      <div className="px-3 py-2">
        <p className={`text-xs font-medium ${isFailure ? 'text-red-500' : 'text-zinc-500'}`}>
          {isFailure ? 'Failure' : 'Success'}
        </p>
        {isFailure && typeof config.reason === 'string' && config.reason && (
          <p className="text-xs text-zinc-400 truncate">{config.reason}</p>
        )}
      </div>
    </div>
  );
}

export default memo(ExitNode);
